import LoaderPage from 'components/ui/feedback/LoaderPage'
import useAdminSettings from 'hooks/useAdminSettings'
import { lazy } from 'react'
import { Navigate, Route, RouteProps, Routes } from 'react-router-dom'

const CollectionsV2Page = lazy(() => import('pages/collectionsv2/page'))

const CollectionsV2Routes: React.FunctionComponent<RouteProps> = () => {
  const { enableCollectionsV2 } = useAdminSettings()

  return (
    <Routes>
      <Route
        path="/"
        element={enableCollectionsV2 ? <LoaderPage content={<CollectionsV2Page />} /> : <Navigate to="/collections" replace />}
      />
    </Routes>
  )
}

export default CollectionsV2Routes
